import { setGenericEvent } from 'features/tealium/ga4/custom';
import { postRecommendedItemTrack } from 'features/tealium/dynamicYield/api';

import { getDySessionId, isDyProductRecommendationsEnabled } from './dynamicYield/helpers';

const trackSortMoreYouMayLike = () => {

	const selector = window.utag_data?.is_mobile === '1'
		? '#sortMoreYouMayLike .sortMoreYouMayLikeItem a[data-position]'
		: '#moreYouMayLikeContainer .moreYouLikeLink';
	const moreYouMayLikeLinks = document.querySelectorAll(selector);
	moreYouMayLikeLinks.forEach((linkElement) => {

		linkElement.addEventListener('click', () => {

			const decisionId = linkElement.closest('[data-decisionid]').getAttribute('data-decisionid');
			const { position, slotid } = linkElement.dataset;

			if (position) {

				setGenericEvent({
					event_name: 'sort_moreyoumaylike_click',
					item_position_number: position
				});

			}

			if (isDyProductRecommendationsEnabled()) {

				postRecommendedItemTrack({
					SlotId: slotid,
					DecisionId: decisionId,
					DySessionId: getDySessionId()
				});

			}

		}, {
			once: true
		});

	});

};

export default trackSortMoreYouMayLike;
